import OMT_UI_ScrollBar from '../../OMT_UI/Scroll/OMT_UI_ScrollBar';
import OMT_UI_ScrollBarConfig from '../../OMT_UI/Scroll/OMT_UI_ScrollBarConfig';
import WorldMap from '../../Elements/WorldMap/WorldMap';
import { MapEditorSidePanel } from './MapEditorSidePanel';
import { EditorStorageManager } from './EditorStorageManager';

export class MapEditor {
  /**
   * initialize the map / world editor state
   * @param {string} lvlId id of level to open for editing
   */
  init(lvlId) {
    this.NOTRESIZABLE = true;
    this.EDITOR = true;
    this._storageManager = EditorStorageManager.getInstance();

    this._lastLvlId = lvlId;
    this._selectedLevels = [];
    this.stage.backgroundColor = 0x072766;

    this.fillSaveState3Stars();
  }

  /**
   * create the map / world editor state
   */
  create() {
    // set world scale / game window size
    game.world.setBounds(0, 0, game.width, game.height);
    game.scale.setGameSize(2300, 1300);

    // init World Map and Editor side panel
    this._initWorldMap();
    this._initMapEditorSidePanel();

    this._initMapScrollArea();
    this._initInputEvents();

    // center editor ot last edited level
    if (this._lastLvlId !== undefined) this._centerOnId(this._lastLvlId);
  }

  /**
   * init map editor world map
   */
  _initWorldMap() {
    this._map = new WorldMap(G.json.settings.mapTiles, [], null, true);
    this._map.signals.onGateOpen.add(this._openGate, this);
  }

  /**
   * init the map editor side panel
   */
  _initMapEditorSidePanel() {
    this._sidePanel = new MapEditorSidePanel(1400, 10);
    this._sidePanel.signals.onPathChanged.add(this._onPathChanged, this);
  }

  /**
   * called on a path modification
   */
  _onPathChanged() {
    this._storageManager.savePathChanges();
    this._sidePanel.refresh();
  }

  /**
   * init the map scroll area / scrollbar
   */
  _initMapScrollArea() {
    const scrollBarConfig = new OMT_UI_ScrollBarConfig(40, 5, 0, null, null, null, 'shop2', 'scrollbar_slide', true, 'scrollbar_bg');
    const scrollBar = new OMT_UI_ScrollBar(new Phaser.Rectangle(0, 0, 1350, 1300), scrollBarConfig);
    scrollBar.updateScrollKnobGraphics(0.1);
    game.world.add(scrollBar);
    scrollBar.signals.onScrollChange.add(() => {
      const percentage = (1 - scrollBar.getScrollPercent());
      this._map.goToPositionY(this._map.mapHeight * percentage);
    });

    this._map.signals.onMapScrolled.add(() => {
      const percentage = (1 - (this._map.y / this._map.mapHeight));
      scrollBar.setScrollPercent(percentage, false);
    });
  }

  /**
   * init the user input events / controls
   */
  _initInputEvents() {
    this._keys = game.input.keyboard.addKeys({
      C: Phaser.Keyboard.C,
      M: Phaser.Keyboard.M,
      CTRL: Phaser.Keyboard.CONTROL,
    });

    this.cursors = game.input.keyboard.createCursorKeys();
    game.input.onDown.add(() => { }, this);
    game.input.keyboard.addKey(Phaser.Keyboard.H).onDown.add(() => {
      this._toggleSelectedLevelsDifficulty();
    });
  }

  /**
   * add a levelId to the current level selection
   * @param {string} lvlId
   */
  selectLevel(lvlId) {
    if (typeof lvlId === 'string') {
      if (this._keys.CTRL.isDown) { // handle multiple level selection
        if (this._selectedLevels.includes(lvlId)) { // remove level from selectiom
          this._selectedLevels.splice(this._selectedLevels.indexOf(lvlId), 1);
        } else { // add level to selection
          this._selectedLevels.push(lvlId);
        }
      } else if (this._selectedLevels.includes(lvlId)) { // deselect single level
        this._selectedLevels = [];
      } else { // select single level
        this._selectedLevels = [lvlId];
      }
    } else if (Array.isArray(lvlId)) { // if the levelId is an array replace our selection list
      this._selectedLevels = lvlId;
    } else {
      this._selectedLevels = [];
    }
    // sort levels in selection by id
    this._selectedLevels.sort((a, b) => a - b);

    this._map.editorRefreshButtons();
    G.sb('editorLevelSelected').dispatch();
    this._sidePanel.refresh();
  }

  /**
   * toggle the difficult for the selected level
   */
  _toggleSelectedLevelsDifficulty() {
    this._selectedLevels.forEach((lvlId) => {
      G.Helpers.levelDataMgr.toggleLevelDifficulty(lvlId);
      this._storageManager.saveLevelChanges(lvlId, G.Helpers.levelDataMgr.getRawLevelById(lvlId));
      this._sidePanel.refresh();
    });
    this._map.editorRefreshButtons();
  }

  /**
   * center to level by id
   * @param {string} id
   */
  _centerOnId(id) {
    const index = G.Helpers.levelDataMgr.getIndexOfLevelId(id);
    if (index >= 0) {
      this._map.centerOnLvl(index);
      this.selectLevel(id);
    }
  }

  /**
   * set all levels to 3 stars
   */
  fillSaveState3Stars() {
    G.saveState.data.levels = [];
    for (let i = 0; i < G.Helpers.levelDataMgr.getNumberOfLevels(); i++) {
      G.saveState.data.levels.push(3);
    }
    G.saveState.debugUnlockAllGate(-2, false);
    G.saveState.save();
  }

  /**
   * open gate by id
   * @param {string} gateId
   */
  _openGate(gateId) {
    G.Helpers.gatesMgr.openGate(gateId);
  }

  /**
   * update state
   */
  update() {
    //
  }

  /**
   * render state
   */
  render() {
    const pos = this._map.pointerToInnerPosition(game.input.activePointer);
    game.debug.text(`${pos.x} x ${pos.y}`, 10, 50, '0', '20px Verdana');
  }

  /**
   * get a reference to the selected levels
   * @returns {*}
   */
  get selectedLevels() {
    return this._selectedLevels;
  }

  /**
   * get a reference to the map instance
   * @returns {G.WorldMap}
   */
  get map() {
    return this._map;
  }
}
